import { differenceInHours } from "date-fns";

export class ServiceStatusInformationByStoreModel {
    id: string = "";
    name: string = "";
    idSource: string = "";
    lastConnectionStore: Date|string = "";
    lastConnectionOrder: Date|string = "";

    constructor(s?:Partial<ServiceStatusInformationByStoreModel>) {
        Object.assign(this, s)

        this._parseDates()
    }

    hasBeenAWhileSinceConnectionStock():boolean {
        const HOURS_SINCE_CONNECTION = 3;

        if (!this.hasConnectionStock()) {
            return true
        }

        return differenceInHours(new Date(), this.lastConnectionStore as Date) > HOURS_SINCE_CONNECTION;
    }

    hasBeenAWhileSinceConnectionOrder():boolean {
        const HOURS_SINCE_CONNECTION = 3;

        if (!this.hasConnectionOrder()) {
            return true
        }

        return differenceInHours(new Date(), this.lastConnectionOrder as Date) > HOURS_SINCE_CONNECTION;
    }

    hasConnectionStock():boolean {
        return !!this.lastConnectionStore
    }

    hasConnectionOrder():boolean {
        return !!this.lastConnectionOrder
    }

    private _parseDates():void {
        if (!!this.lastConnectionOrder) {
            this.lastConnectionOrder = new Date(this.lastConnectionOrder)
        }

        if (!!this.lastConnectionStore) {
            this.lastConnectionStore = new Date(this.lastConnectionStore)
        }
    }
}
